import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { VesselData } from '../vessel-data.model';

/**
 * Leaving vessel-reg page and going to login, this dialog is the intermediary that allows going back to keep editing before moving on.
 */
@Component({
    selector: 'app-confirm-dialog',
    templateUrl: './confirm-dialog.component.html',
    styleUrls: ['./confirm-dialog.component.css'],
    standalone: false
})
export class ConfirmDialogComponent implements OnInit {

  title: string = '';
  content: string = '';
  cancelButton: string = '';
  confirmButton: string = '';
  secondScreen: boolean = false;

  //Only for vessel_reg screen
  vessels: VesselData[] = [];

  constructor(public dialogRef: MatDialogRef<ConfirmDialogComponent>, @Inject(MAT_DIALOG_DATA) public data: {screen: string, vessels: VesselData[] | undefined}) { }

  ngOnInit(): void {
    switch (this.data.screen) {
      case "vesselreg":
        this.title = 'Unrecognized Vessels';
        this.content = 'The following vessel(s) are unrecognized by coast guard number. Continue anyway?';
        this.cancelButton = 'Go back and edit';
        this.confirmButton = 'Continue';
        this.vessels = this.data.vessels!;
        break;
      case "unrecognizedvesselsubmit":
        this.title = 'Unrecognized Vessel';
        this.content = 'The following vessel is unrecognized by coast guard number. Review it for typos before submitting. Submit anyway?';
        this.cancelButton = 'Go back and edit';
        this.confirmButton = 'Submit anyway';
        this.vessels = this.data.vessels!;
        break;
      case "deletegear":
        this.title = 'Delete this Gear';
        this.content = 'Are you sure you want to delete this gear? It will be permanently lost. Previously submitted data using this gear will not be affected';
        this.cancelButton = 'Cancel';
        this.confirmButton = 'OK';
        break;
      case "deleteset":
        this.title = 'Delete this Set';
        this.content = 'Are you sure you want to delete this fishing event? All data will be permanently lost';
        this.cancelButton = 'Cancel';
        this.confirmButton = 'OK';
        this.secondScreen = true;
        break;
      case "deletevessel":
        this.title = 'Delete Vessel';
        this.content = 'Are you sure you want to delete this vessel? This cannot be undone';
        this.cancelButton = 'Cancel';
        this.confirmButton = 'OK';
        break;
      case 'noticket':
        this.title = 'Proceed without Fish Ticket(s)';
        this.content = 'No Fish Tickets attached to delivery. Are you sure want to proceed to submit?';
        this.cancelButton = 'Cancel';
        this.confirmButton = 'OK';
        break;
      case 'autofill':
        this.title = 'Confirm autofill';
        this.content = 'Are you sure you want to autofill date/location details?';
        this.cancelButton = 'Cancel';
        this.confirmButton = 'OK';
        break;
      case 'discardedits':
        this.title = 'Discard delivery edits';
        this.content = 'Are you sure you want to discard all your edits on this delivery? This action cannot be undone.';
        this.cancelButton = 'Cancel';
        this.confirmButton = 'OK';
        break;
      case 'changegear':
        this.title = 'Change gear';
        this.content = 'Are you sure you want to change gear? This will reset certain form fields.';
        this.cancelButton = 'Cancel';
        this.confirmButton = 'OK';
        this.secondScreen = true;
        break;
      case 'deletespecies':
        this.title = 'Delete species';
        this.content = 'Are you sure you want to delete this species?';
        this.cancelButton = 'Cancel';
        this.confirmButton = 'OK';
        this.secondScreen = true;
        break;
      case 'deleteunloading':
        this.title = 'Delete unloading';
        this.content = 'Are you sure you want to delete this unloading?';
        this.cancelButton = 'Cancel';
        this.confirmButton = 'OK';
        this.secondScreen = true;
        break;
      case 'emedit':
        this.title = 'Editing EM Trip Logbook';
        this.content = 'Logbooks from EM trips may require revision after your EM service provider reviews logbook and EM drive data. Any changes to data made beyond 7 days post-submission should be prompted from discussion with your EM service provider. You must agree with the changes that your EM service provider requests before making changes and submitting a correction. Only proceed if you agree.';
        this.cancelButton = 'Cancel';
        this.confirmButton = 'I agree, proceed';
        break;
    }

  }


  confirmClck() {
    if (this.data.screen == 'vesselreg' || this.data.screen == 'unrecognizedvesselsubmit' || this.data.screen == 'noticket' || this.data.screen == 'autofill' || this.data.screen == 'emedit') {
      this.dialogRef.close(true);
      return;
    }
    
    if (this.secondScreen) {
      this.dialogRef.close(true);
    } else {
      this.secondScreen = true;
      this.content = 'Are you absolutely certain you want to delete?';
    }
  }

}
